import * as React from "react";
import { Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { DomainPortCorsAllowOriginInput } from "../../../../schema/types/domain/input";
import { store } from "../../../../store";
import { formSet, formSetValue, formTriggerValidation } from "../../../gvc/testNewForm/utils";
import { FormListFieldItem } from "../../../gvc/formListFieldItem";
import { CpSelect } from "../../../gvc/testNewForm/CpSelect";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";

interface Props {
  name?: string;
  item?: DomainPortCorsAllowOriginInput;
  index?: number;
}
export const CpArrayItemAllowOrigin: React.FC<Props> = React.memo(({ name: _name, item: _item, index: _index }) => {
  const { id } = useCpFormContext();

  const name = _name!;
  const item = _item!;
  const index = _index!;

  function remove() {
    const form = store.getState().form.instances[id];
    const values = form.values;

    const items = get(values, name) || [];
    let _items = cloneDeep(items);
    _items = _items.filter((i) => i.id !== item.id);
    formSetValue(id, name, _items);

    formTriggerValidation(id);
  }

  return (
    <FormListFieldItem columnCount={4} hasRemoveButton className="mb-1">
      <CpSelect
        name={`${name}.${index}.type`}
        options={[
          { label: "Exact", value: "exact" },
          { label: "Regex", value: "regex" },
        ]}
        className="col-span-1"
      />
      <CpInput name={`${name}.${index}.value`} className="col-span-3" />
      <Button type={`text`} danger icon={<MinusCircleOutlined />} onClick={() => remove()} />
    </FormListFieldItem>
  );
});
